import React from 'react';
import { Route, Routes as ReactRoutes } from "react-router-dom";

import Layout from "../pages/_partials/Layout";
import Dashboard from "../pages/Dashboard";
import NotFound from "../pages/NotFound";

import minecraftRoutes from "./mine_craft/minecraftRoutes";
import cartoondrawRoutes from "./cartoondraw/cartoondrawRoutes";
import stickerMakerRoutes from "./sticker_maker/stickerMakerRoutes";
import robloxRoutes from "./roblox/robloxRoutes";
import modsfactoryRoutes from "./mods_factory/modsfactoryRoutes";
import communityRoutes from "./community/communityRoutes";
import callrecorderRoutes from "./callrecorder/callrecorderRoutes";
import watcherRoutes from "./watcher/watcherRoutes";

const Routes: React.FC = () => {
  const renderRoutes = (routes: any[], keyPrefix: string) => {
    return routes.map((route, index) => (
      <Route key={`${keyPrefix}-${index}`} path={route.path} element={route.element} />
    ));
  }

  return(
    <ReactRoutes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route key='dashboard-status' path='/dashboard/status/hosts' element={<Dashboard />} />
        <Route key='dashboard-status' path='/dashboard/reports/analytics' element={<Dashboard />} />
        <Route key='dashboard-status' path='/dashboard/reports/uptime' element={<Dashboard />} />
        <Route key='dashboard-status' path='/dashboard/reports/events' element={<Dashboard />} />

        {renderRoutes(cartoondrawRoutes, 'cartoondraw')}
        {renderRoutes(minecraftRoutes, 'minecraft')}
        {renderRoutes(stickerMakerRoutes, 'sticker_maker')}
        {renderRoutes(robloxRoutes, 'roblox')}
        {renderRoutes(modsfactoryRoutes, 'modsfactory')}
        {renderRoutes(communityRoutes, 'community')}
        {renderRoutes(callrecorderRoutes, 'callrecorder')}
        {renderRoutes(watcherRoutes, 'watcher')}
      </Route>

      <Route path="*" element={<NotFound />} />
    </ReactRoutes>
  );
}

export default Routes;
